import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { registerService } from "src/app/shared/services/register-person.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-anexo-juridico",
  templateUrl: "./anexo-juridico.component.html",
  styleUrls: ["./anexo-juridico.component.scss"],
})
export class AnexoJuridicoComponent implements OnInit {
  dataTwo;
  constructor(
    private modalService: NgbModal,
    private modalService2: NgbModal,

    private _Register: registerService,
    private fb: FormBuilder
  ) {
    this.vengaelEstado();
  }

  estAct1;
  estAct2;
  estAct3;
  estAct4;
  estAct5;
  estAct6;
  estAct7;
  estAct8;
  departamentoAnexoDjFiscal;
  departamentosAnexoDjFiscal;


  vengaelEstado() {
    this._Register.estadodelFormulario().subscribe((res) => {

      if (res.indiceFormulario == "AUTHORIZED_PERSONS_LEGAL") {
        this.estAct1 = true;
        this.estAct4 = false;
        this.estAct5 = true;
        this.estAct3 = false;
        this.estAct8 = true;
        this.prosigue = true;


      }


      if (res.indiceFormulario == "DJ_TAX_RESIDENCE_ANNEX_LEGAL") {
        this.estAct1 = false;
        this.estAct4 = true;
        this.estAct5 = false;
        this.estAct2 = false;

        this.estAct3 = false;
        this.estAct8 = true;
        this.estAct7 = false;

        this.prosigue = true;
      }
      if (res.indiceFormulario == "DJ_PEP_ANNEX_LEGAL") {
        this.estAct1 = false;
        this.estAct4 = false;
        this.estAct5 = false;

        this.estAct2 = true;
        this.estAct3 = true;
        this.estAct8 = false;
        this.estAct7 = false;
        this.prosigue = true;
      }

      if (res.indiceFormulario == "DJ_INSTITUTIONAL_INVESTOR_ANNEX_LEGAL") {
        this.estAct1 = false;
        this.estAct4 = false;
        this.estAct5 = false;
        this.estAct3 = false;
        this.estAct8 = false;


        this.estAct2 = true;
        this.estAct7 = true;
        this.prosigue = false;
      }
    });
  }

  ngOnInit() {

    this.cargarDepartamentos()
    this.dataTwo = [
      "A) ENTIDAD DE INVERSIÓN1 LOCALIZADA EN UNA JURISDICCIÓN NO PARTICIPANTE2 Y ADMINISTRADA POR OTRA INSTITUCIÓN FINANCIERA",
      "B) OTRA ENTIDAD DE INVERSIÓN",
      "C) INSTITUCIÓN FINANCIERA- INSTITUCIÓN DE DEPÓSITO4, INSTITUCIÓN DE CUSTODIA5 O COMPAÑÍA DE SEGUROS",
      "D) ENF ACTIVA7, CUYAS ACCIONES DE LA ENTIDAD SEAN REGULARMENTE COMERCIALIZADAS EN UNA BOLSA DE VALORES ESTABLECIDA O LA ENTIDAD ES UNA ENTIDAD RELACIONADA DE UNA ENTIDAD CUYAS ACCIONES SE COMERCIALIZAN EN UN MERCADO DE VALORES ESTABLECIDO",
      "E) ENF ACTIVA –ENTIDAD GUBERNAMENTAL O BANCO CENTRAL",
      "F) ENF ACTIVA – ORGANIZACIÓN INTERNACIONAL",
      "G) ENF ACTIVA DISTINTA DE D) Y F)",
      "H) ENF PASIVA",
    ];
  }
  cerrar() {
    this.modalService.dismissAll();
  }

  abrirAnexo() {
    this.modalService
      .open(AnexoJuridicoComponent, { windowClass: "dark-modal", size: "lg" })
      .result.then(
        (result) => {
        },
        (reason) => {
          console.log(reason);
        }
      );
  }

  openOneModal(content) {
    this.modalService2
      .open(content, {
        windowClass: "dark-modal",
        size: "lg",
        backdropClass: "light-blue-backdrop",
      })
      .result.then(
        (result) => {
        },
        (reason) => {
          this.abrirAnexo();
        }
      );
  }
  valor: string | boolean = false;

  orders = [
    {
      id: 1,
      name: "1. La información proporcionada es correcta y completa.",
    },
    {
      id: 2,
      name: "2. No tengo nacionalidad o residencia fiscal en otros países que no haya colocado en esta Declaración.",
    },
    {
      id: 3,
      name: "3. Autorizo la INVERSIÓN Y DESARROLLO SAB S.A.C. - IND SAB a proporcionar directa o indirectamente, la información contenida en esta Declaración y/o proporcionar una copia a SUNAT o cualquier entidad autorizada para auditar o realizar un control a INVERSIÓN Y DESARROLLO SAB S.A.C. - IND SAB. Asimismo, autorizo se entregue copia de la presente declaración a las Instituciones de Compensación y Liquidación de Valores (ICLV), conforme a la normativa vigente.",
    },
    {
      id: 4,
      name: "4. Me comprometo a comunicar al INVERSIÓN Y DESARROLLO SAB S.A.C. - IND SAB sobre cualquier cambio de circunstancias para la presente Declaración y actualizarla en un plazo de 30 días a partir de la fecha de cambio.",
    },
  ];

  ordersfsfsstwo = [
    {
      id: 1,
      caption:
        "Por la presente declaro que me encuentro dentro de los alcances de la Resolución de Superintendencia Nro. 00021-2013-SMV/01 y su anexo 01 referente a las personas calificadas como inversionistas institucionales.",
    },
    {
      id: 2,
      caption:
        "Por este motivo declaro mi condición como Inversionista Institucional a IND, para los fines correspondientes.",
    },
  ];


  paqueteSelected = "";
  paqueteSelected2 = "";

  boxing;
  boxing2;
  optionD(event) {

    if (
      event == "H) ENF PASIVA" ||
      event ==
      "A) ENTIDAD DE INVERSIÓN1 LOCALIZADA EN UNA JURISDICCIÓN NO PARTICIPANTE2 Y ADMINISTRADA POR OTRA INSTITUCIÓN FINANCIERA"
    ) {
      this.boxing2 = true;
    } else {
      this.boxing2 = false;
    }
  }

  optionC(event) {
    if (event == "Si") {
      this.boxing = true;
    } else {
      this.boxing = false;
    }
  }

  check1;
  check2;
  check3;
  valorInput() {
    this.check1 = true;
  }
  /* ACA COMIENZA EL TERCERO */

  form: FormGroup = this.fb.group({
    questone: ["", [Validators.required]],
    questtwo: ["", [Validators.required]],
  });

  form2: FormGroup = this.fb.group({
    quest1: ["", [Validators.required]],
    quest2: ["", [Validators.required]],
    quest3: ["", [Validators.required]],
    quest4: ["", [Validators.required]],
    quest5: ["", [Validators.required]],
    quest6: ["", [Validators.required]],
    quest7: ["", [Validators.required]],
    quest8: ["", [Validators.required]],
    quest9: ["", [Validators.required]],
    quest10: ["", [Validators.required]],
  });

  form3: FormGroup = this.fb.group({
    quest1: ["", [Validators.required]],
    quest2: [""],
    quest3: [""],
    quest4: ["", [Validators.required]],
    quest5: [""],
    quest6: [""],
    quest7: [""],
    quest8: [""],
    quest9: [""],
    quest10: [""],
    quest11: [""],
    quest12: [""],
    quest13: [""],
    quest14: [""],
    quest15: ["", [Validators.required]],
    quest16: ["", [Validators.required]],
    quest17: ["", [Validators.required]],
    quest18: ["", [Validators.required]],
  });

  validarOneAnexo() {
    if (
      this.form3.get("quest1").value == "" ||
      this.form3.get("quest1").value == undefined ||
      this.form3.get("quest1").value == null
    ) {
      Swal.fire("Debe completar todos los campos", "", "warning");
      return;
    }
    if (this.form3.get("quest1").value == "Si") {
      if (
        this.form3.get("quest2").value == "" ||
        this.form3.get("quest2").value == undefined ||
        this.form3.get("quest2").value == null
      ) {
        Swal.fire("Debe completar todos los campos", "", "warning");
        return;
      }
      if (
        this.form3.get("quest3").value == "" ||
        this.form3.get("quest3").value == undefined ||
        this.form3.get("quest3").value == null
      ) {
        Swal.fire("Debe completar todos los campos", "", "warning");
        return;
      }
    }

    if (
      this.form3.get("quest4").value == "" ||
      this.form3.get("quest4").value == undefined ||
      this.form3.get("quest4").value == null
    ) {
      Swal.fire("Debe completar todos los campos", "", "warning");
      return;
    }
    if (
      this.form3.get("quest4").value == "H) ENF PASIVA" ||
      this.form3.get("quest4").value ==
      "A) ENTIDAD DE INVERSIÓN1 LOCALIZADA EN UNA JURISDICCIÓN NO PARTICIPANTE2 Y ADMINISTRADA POR OTRA INSTITUCIÓN FINANCIERA"
    ) {
      if (
        this.form3.get("quest5").value == "" ||
        this.form3.get("quest5").value == undefined ||
        this.form3.get("quest5").value == null
      ) {
        Swal.fire("Debe completar todos los campos", "", "warning");
        return;
      }
      if (
        this.form3.get("quest6").value == "" ||
        this.form3.get("quest6").value == undefined ||
        this.form3.get("quest6").value == null
      ) {
        Swal.fire("Debe completar todos los campos", "", "warning");
        return;
      }
      if (
        this.form3.get("quest7").value == "" ||
        this.form3.get("quest7").value == undefined ||
        this.form3.get("quest7").value == null
      ) {
        Swal.fire("Debe completar todos los campos", "", "warning");
        return;
      }
      if (
        this.form3.get("quest8").value == "" ||
        this.form3.get("quest8").value == undefined ||
        this.form3.get("quest8").value == null
      ) {
        Swal.fire("Debe completar todos los campos", "", "warning");
        return;
      }
      if (
        this.form3.get("quest9").value == "" ||
        this.form3.get("quest9").value == undefined ||
        this.form3.get("quest9").value == null
      ) {
        Swal.fire("Debe completar todos los campos", "", "warning");
        return;
      }
      if (
        this.form3.get("quest10").value == "" ||
        this.form3.get("quest10").value == undefined ||
        this.form3.get("quest10").value == null
      ) {
        Swal.fire("Debe completar todos los campos", "", "warning");
        return;
      }

      if (
        this.form3.get("quest11").value == "" ||
        this.form3.get("quest11").value == undefined ||
        this.form3.get("quest11").value == null
      ) {
        Swal.fire("Debe completar todos los campos", "", "warning");
        return;
      }

      if (
        this.form3.get("quest12").value == "" ||
        this.form3.get("quest12").value == undefined ||
        this.form3.get("quest12").value == null
      ) {
        Swal.fire("Debe completar todos los campos", "", "warning");
        return;
      }

      if (
        this.form3.get("quest13").value == "" ||
        this.form3.get("quest13").value == undefined ||
        this.form3.get("quest13").value == null
      ) {
        Swal.fire("Debe completar todos los campos", "", "warning");
        return;
      }

      if (
        this.form3.get("quest14").value == "" ||
        this.form3.get("quest14").value == undefined ||
        this.form3.get("quest14").value == null
      ) {
        Swal.fire("Debe completar todos los campos", "", "warning");
        return;
      }
    }
    if (
      this.form3.get("quest15").value == "" ||
      this.form3.get("quest15").value == undefined ||
      this.form3.get("quest15").value == null
    ) {
      Swal.fire("Debes aceptar los terminos", "", "warning");
      return;
    }
    if (
      this.form3.get("quest16").value == "" ||
      this.form3.get("quest16").value == undefined ||
      this.form3.get("quest16").value == null
    ) {
      Swal.fire("Debes aceptar los terminos", "", "warning");
      return;
    }

    if (
      this.form3.get("quest17").value == "" ||
      this.form3.get("quest17").value == undefined ||
      this.form3.get("quest17").value == null
    ) {
      Swal.fire("Debes aceptar los terminos", "", "warning");
      return;
    }

    if (
      this.form3.get("quest18").value == "" ||
      this.form3.get("quest18").value == undefined ||
      this.form3.get("quest18").value == null
    ) {
      Swal.fire("Debes aceptar los terminos", "", "warning");
      return;
    } else {
      return true;
    }
  }

  validarTwoAnexo() {
    if (
      this.form2.get("quest1").value == "" ||
      this.form2.get("quest1").value == undefined ||
      this.form2.get("quest1").value == null
    ) {
      Swal.fire("Debe completar todos los campos", "", "warning");
      return;
    }
    if (
      this.form2.get("quest2").value == "" ||
      this.form2.get("quest2").value == undefined ||
      this.form2.get("quest2").value == null
    ) {
      Swal.fire("Debe completar todos los campos", "", "warning");
      return;
    }
    if (
      this.form2.get("quest3").value == "" ||
      this.form2.get("quest3").value == undefined ||
      this.form2.get("quest3").value == null
    ) {
      Swal.fire("Debe completar todos los campos", "", "warning");
      return;
    }
    if (
      this.form2.get("quest4").value == "" ||
      this.form2.get("quest4").value == undefined ||
      this.form2.get("quest4").value == null
    ) {
      Swal.fire("Debe completar todos los campos", "", "warning");
      return;
    }
    if (
      this.form2.get("quest5").value == "" ||
      this.form2.get("quest5").value == undefined ||
      this.form2.get("quest5").value == null
    ) {
      Swal.fire("Debe completar todos los campos", "", "warning");
      return;
    }
    if (
      this.form2.get("quest6").value == "" ||
      this.form2.get("quest6").value == undefined ||
      this.form2.get("quest6").value == null
    ) {
      Swal.fire("Debe completar todos los campos", "", "warning");
      return;
    }
    if (
      this.form2.get("quest7").value == "" ||
      this.form2.get("quest7").value == undefined ||
      this.form2.get("quest7").value == null
    ) {
      Swal.fire("Debe completar todos los campos", "", "warning");
      return;
    }
    if (
      this.form2.get("quest8").value == "" ||
      this.form2.get("quest8").value == undefined ||
      this.form2.get("quest8").value == null
    ) {
      Swal.fire("Debe completar todos los campos", "", "warning");
      return;
    }
    if (
      this.form2.get("quest9").value == "" ||
      this.form2.get("quest9").value == undefined ||
      this.form2.get("quest9").value == null
    ) {
      Swal.fire("Debe completar todos los campos", "", "warning");
      return;
    }
    if (
      this.form2.get("quest10").value == "" ||
      this.form2.get("quest10").value == undefined ||
      this.form2.get("quest10").value == null
    ) {
      Swal.fire("Debe completar todos los campos", "", "warning");
      return;
    } else {
      return true;
    }
  }

  validar() {
    if (
      this.form.get("questone").value == "" ||
      this.form.get("questone").value == undefined ||
      this.form.get("questone").value == null
    ) {
      Swal.fire("Lo sentimos tiene que aceptar los terminos", "", "warning");
      return;
    }
    if (
      this.form.get("questtwo").value == "" ||
      this.form.get("questtwo").value == undefined ||
      this.form.get("questtwo").value == null
    ) {
      Swal.fire("Lo sentimos tiene que aceptar los terminos", "", "warning");
      return;
    } else {
      return true;
    }
  }
  prosigue;
  dataChecks: any = [];
  datoAcc1;
  datoAcc2;
  dataForm: any = [];
  dataFormOne: any = [];
  saveOneAnexo() {
    var validar = this.validarOneAnexo();
    if (validar) {
      this.dataFormOne = {
        obligacion_fiscales: this.form3.get("quest1").value,
        obligacion_fiscales_pais: this.form3.get("quest2").value,
        obligacion_fiscales_nit: this.form3.get("quest3").value,
        tip_entid: this.form3.get("quest4").value,
        nombres: this.form3.get("quest5").value,
        apellidos: this.form3.get("quest6").value,
        fec_nac: this.form3.get("quest7").value,
        tip_doc: this.form3.get("quest8").value,
        num_doc: this.form3.get("quest9").value,
        pais: this.form3.get("quest10").value,
        pais_nac: this.form3.get("quest11").value,
        departa: this.form3.get("quest12").value,
        obli_other_paises: this.form3.get("quest13").value,
        dir_domic: this.form3.get("quest14").value,
        term_1: this.form3.get("quest15").value,
        term_2: this.form3.get("quest16").value,
        term_3: this.form3.get("quest17").value,
        term_4: this.form3.get("quest18").value,
      };

      let data = {
        datos_anexo_pep: JSON.stringify(this.dataFormOne),
      };
      this._Register.anexoOneJuridico(data).subscribe(
        (response: any) => {
          this.estAct1 = false;
          this.estAct4 = true;
          this.estAct5 = false;
          this.modalService2.dismissAll();
        },
        (error) => {
          Swal.fire(error.error.statusMessage, "", "warning");
          return;
        }
      );
    } else {
      return;
    }
  }

  saveTwoAnexo() {
    var validar = this.validarTwoAnexo();
    if (validar) {
      this.dataForm = {
        nombre: this.form2.get("quest1").value,
        apellido: this.form2.get("quest2").value,
        tip_doc: this.form2.get("quest3").value,
        nro_doc: this.form2.get("quest4").value,
        parent: this.form2.get("quest5").value,
        razo_soc: this.form2.get("quest6").value,
        tip_doc_pers_jur: this.form2.get("quest7").value,
        nro_doc_pers_jur: this.form2.get("quest8").value,
        pais_pers_jur: this.form2.get("quest9").value,
        part_pers_jur: this.form2.get("quest10").value,
      };

      let data = {
        datos_anexo_pep: JSON.stringify(this.dataForm),
      };

      this._Register.anexoTwoJuridico(data).subscribe(
        (response: any) => {
         
          this.estAct2 = true;
          this.estAct4 = false;
          this.estAct3 = true;
          this.estAct8 = false;
          this.modalService2.dismissAll();
        },
        (error) => {
          Swal.fire(error.error.statusMessage, "", "warning");
          return;
        }
      );
    } else {
      return;
    }
  }

  saveTreeAnexo() {
    var validar = this.validar();
    if (validar) {
      this.dataChecks = {
        declaracion_one: this.form.get("questone").value,
        declaracion_two: this.form.get("questtwo").value,
      };

      let data = {
        datos_anexo_pep: JSON.stringify(this.dataChecks),
      };

      this._Register.anexoTreeJuridico(data).subscribe(
        (response: any) => {
          this.estAct7 = true;
          this.estAct3 = false;
          this.prosigue = false;
          this.modalService2.dismissAll();
        },
        (error) => {
          Swal.fire(error.error.statusMessage, "", "warning");
          return;
        }
      );
    } else {
      return;
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  formSubmitted = false;
  customYearValues = [2006, 1970];

  lettersOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 33 || charCode > 64)) {
      return true;
    }
    return false;
  }

  registrarAnexo() {
    Swal.fire(
      "¡Ya casi terminamos! Para finalizar, por favor continúe con el proceso de firma electrónica de los documentos",
      "",
      "success"
    );
    this._Register.showBtnAccesoFirmaJuridico();
    this.modalService.dismissAll();


  }

  cargarDepartamentos() {
    this._Register.getDepartamentos().subscribe(
      (resp) => {

        this.departamentosAnexoDjFiscal = resp;
      },
      (error) => {
        console.log("Ha ocurrido un error!")
        console.log(error);
      }
    )
  }

}
